import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits, parseUnits } from "viem";

const useDepositEstimate = (amount: string) => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();

  const formattedAmount = !Number.isNaN(amount) ? parseUnits(amount, 18) : "0";

  const { data } = useReadContract({
    ...config.interactionPools.lrtDepositPool,
    functionName: "viewSwapRsETHAmountAndFee",
    args: [formattedAmount],
    query: {
      enabled:
        chain &&
        isRestakeSupported &&
        !isEthereumChain &&
        formattedAmount !== "0",
    },
  });

  return data
    ? {
        returns: formatUnits((data as any)[0] as bigint, 18),
        fees: formatUnits((data as any)[1] as bigint, 18),
      }
    : { returns: "0", fees: "0" };
};

export default useDepositEstimate;
